import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Send } from 'lucide-react';
export function Contact() {
  const phoneNumber = '0952224610';
  const displayPhone = '095 222 4610';
  return <section id="contact" className="py-32 bg-neutral-50" data-id="element-28">
      <div className="container mx-auto px-6" data-id="element-29">
        <div className="max-w-5xl mx-auto" data-id="element-30">
          <div className="bg-white p-12 md:p-20 border border-neutral-200" data-id="element-31">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-32">
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} data-id="element-33">
                <h2 className="text-4xl md:text-5xl font-normal tracking-tight text-neutral-900 mb-6" data-id="element-34">
                  Почніть з <br data-id="element-35" />
                  <span className="font-semibold" data-id="element-36">консультації</span>
                </h2>
                <p className="text-lg text-neutral-600 font-normal mb-12" data-id="element-37">
                  Опишіть вашу ситуацію, і я надам первинну оцінку перспектив
                  справи. Відповідаю швидко.
                </p>

                <a href={`tel:${phoneNumber}`} className="inline-flex items-center gap-4 text-3xl font-normal text-neutral-900 hover:text-neutral-500 transition-colors mb-4" data-id="element-38">
                  <Phone className="w-8 h-8" strokeWidth={1.5} data-id="element-39" />
                  {displayPhone}
                </a>
                <p className="text-sm text-neutral-400 uppercase tracking-widest" data-id="element-40">
                  Телефонуйте щодня
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} className="flex flex-col gap-4" data-id="element-41">
                <a href={`https://t.me/+38${phoneNumber}`} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between p-6 bg-neutral-50 hover:bg-neutral-100 border border-neutral-200 transition-all group" data-id="element-42">
                  <div className="flex items-center gap-4" data-id="element-43">
                    <Send className="w-6 h-6 text-neutral-900" strokeWidth={1.5} data-id="element-44" />
                    <span className="text-lg font-medium text-neutral-900" data-id="element-45">
                      Написати в Telegram
                    </span>
                  </div>
                  <span className="text-neutral-400 group-hover:text-neutral-900 transition-colors" data-id="element-46">
                    →
                  </span>
                </a>

                <a href={`viber://chat?number=%2B38${phoneNumber}`} className="flex items-center justify-between p-6 bg-neutral-50 hover:bg-neutral-100 border border-neutral-200 transition-all group" data-id="element-47">
                  <div className="flex items-center gap-4" data-id="element-48">
                    <MessageCircle className="w-6 h-6 text-neutral-900" strokeWidth={1.5} data-id="element-49" />
                    <span className="text-lg font-medium text-neutral-900" data-id="element-50">
                      Написати у Viber
                    </span>
                  </div>
                  <span className="text-neutral-400 group-hover:text-neutral-900 transition-colors" data-id="element-51">
                    →
                  </span>
                </a>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}